import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../../../shared/CurrencyContext';
import ContractCases from './ContractCases';

const ContractItems = ({ contractId, items, readOnly = true }) => {
  const { t } = useTranslation();
  const { formatCurrency } = useCurrency();

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5>{t('contracts.tabs.items')}</h5>
        {readOnly && (
          <span className="badge bg-info-lt">{t('contracts.contractReadOnly')}</span>
        )}
      </div>

      {items.length === 0 ? (
        <div className="text-center py-4">
          <p className="text-muted">{t('contracts.noItems')}</p>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>{t('contracts.fields.item')}</th>
                <th>{t('contracts.fields.itemType')}</th>
                <th>{t('contracts.fields.quantity')}</th>
                <th>{t('contracts.fields.rateType')}</th>
                <th>{t('contracts.fields.timeUnits')}</th>
                <th>{t('contracts.fields.order')}</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id}>
                  <td>{item.item_name}</td>
                  <td>{item.item_type || '-'}</td>
                  <td>{item.quantity}</td>
                  <td>
                    <span className={`badge ${item.rate_type === 'days' ? 'bg-primary-lt' : 'bg-info-lt'}`}>
                      {item.rate_type === 'days' ? t('contracts.days') : t('contracts.hours')}
                    </span>
                  </td>
                  <td>{item.time_units}</td>
                  <td>{item.order}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mt-4">
        <ContractCases contractId={contractId} mode="items" />
      </div>
    </div>
  );
};

export default ContractItems;
